import { render } from "./EconomicIndicatorList.vue?vue&type=template&id=411fe7f3&scoped=true"
import script from "./EconomicIndicatorList.vue?vue&type=script&lang=js"
export * from "./EconomicIndicatorList.vue?vue&type=script&lang=js"

import "./EconomicIndicatorList.vue?vue&type=style&index=0&id=411fe7f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411fe7f3"]])

export default __exports__